import { Calendar } from "primereact/calendar"
import { useTranslation } from "react-i18next";

import { ResponsiveContainer, CartesianGrid, XAxis, YAxis, Legend, Tooltip, Bar, ComposedChart, Label, LabelList } from "recharts"


export const Sp02HistoryGraph = ({
    sp02Data,
    date,
    onDateChange = (e) => { }
}) => {

    const [t] = useTranslation(["global", "health"]);

    // Funzioni per ottenere inizio e fine della giornata
    const getStartOfDay = () => Math.floor(date.setHours(0, 0, 0, 0));
    const getEndOfDay = () => Math.floor(date.setHours(23, 59, 59, 999));

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip bg-dark card">
                    <div className="card-header"><b>{payload[0].value}</b> %</div>
                    <div className="card-footer"> {new Date(label * 1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}</div>

                </div>
            );
        }

        return null;
    };

    const renderCustomizedLabel = (props) => {
        const { x, y, width, height, value } = props;
        const radius = 15;
        return (
            <g>
                <circle cx={x + width / 2} cy={y} r={radius} fill="#fff" />
                <text x={x + width / 2} y={y} fill="#000" textAnchor="middle" dominantBaseline="middle">
                    {value}
                </text>
            </g>
        );
    };

    return <div className="card mt-2 bg-black bg-opacity-10 text-white p-4">

        {/* BPM Massimo e Minimo */}
        <div className="d-flex  justify-content-between mb-3">
            <div>
                <h4><i className="fa-solid fa-droplet text-muted"></i> {t("health:entity.data.sp02")}</h4>
                <span className="small text-muted">{sp02Data.length} {t("health:unit.measurements", { count: sp02Data.length })}</span>
            </div>

            <div>
                <Calendar value={date} onChange={(e) => onDateChange(e.value)} dateFormat="dd/mm/yy" />
            </div>

        </div>

        {/* Grafico */}
        {
            sp02Data?.length > 0 ?
                <ResponsiveContainer width="100%" height={250}>
                    <ComposedChart data={sp02Data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                        <CartesianGrid strokeDasharray="3 3" opacity={0.5}/>
                        <XAxis
                            dataKey="timestamp"
                            type="number"
                            domain={[getStartOfDay() / 1000, getEndOfDay() / 1000]}
                            ticks={[(getStartOfDay() / 1000, getStartOfDay() / 1000) + 21600, (+getStartOfDay() / 1000) + 43200, (+getStartOfDay() / 1000) + 64800, getEndOfDay() / 1000]}
                            tickFormatter={(tick) =>
                                new Date(tick * 1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })
                            }
                        //scale="time"
                        />
                        <YAxis
                            dataKey="sp02"
                            type="number"
                            domain={[85, 100]}
                            ticks={[85, 90, 95, 100]}
                        />
                        <Tooltip content={CustomTooltip} />
                        <Legend />
                        <Bar type="monotone" dataKey="sp02" barSize={20} name="SP02 %" fill="#0098db" stroke="#0098db" strokeWidth={2} >
                            <LabelList dataKey="sp02" content={renderCustomizedLabel} />
                        </Bar>
                    </ComposedChart>
                </ResponsiveContainer>
                : <h3 className="text-muted">{t("health:helper.no_data")}</h3>
        }

    </div>



}